import Model from "./Model";
import ProcessStatusGroup from "./ProcessStatusGroup";

export const PROCESS_STATUS_IN_REVIEW = 'IN_REVIEW';
export const PROCESS_STATUS_SELLING = 'SELLING';
export const PROCESS_STATUS_SOLD = 'SOLD';
export const PROCESS_STATUS_REJECTED = 'REJECTED';
export const PROCESS_STATUS_SOLD_CONFIRMED = 'SOLD_CONFIRMED';
export const PROCESS_STATUS_RETURNING = 'RETURNING';
export const PROCESS_STATUS_DELIVERED = 'DELIVERED';
export const PROCESS_STATUS_SHIPPED = 'SHIPPED';
export const PROCESS_STATUS_PAYMENT_SENT = 'PAYMENT_SENT';
export const PROCESS_STATUS_RETURNED_TO_SELLER = 'RETURNED_TO_SELLER';

class ProcessStatus extends Model {
  constructor(options) {
    super();
    (this as any).process_status_group = d => {
      return new ProcessStatusGroup(d.data);
    };
    this.bind(options);
  }
}

export default ProcessStatus;
